
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M7.59 12l1.12-1.12L9.84 12 11 10.91 9.84 9.78 11 8.66 9.84 7.53 8.71 8.66 7.59 7.53 6.45 8.66l1.14 1.12-1.14 1.13zM12 14.16a5.85 5.85 0 00-5.43 3.72h10.88A5.83 5.83 0 0012 14.16zm4.44-6.63l-1.1 1.13-1.13-1.13-1.12 1.13 1.12 1.12-1.12 1.13L14.21 12l1.13-1.12L16.46 12l1.14-1.12-1.14-1.1 1.14-1.12z"}}),_c('path',{attrs:{"d":"M12 1.41A10.62 10.62 0 1022.65 12 10.61 10.61 0 0012 1.41zm0 19.12a8.5 8.5 0 118.5-8.5 8.5 8.5 0 01-8.5 8.5z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      